t = require('app/scripts/views/internal/teacup-with-helpers')('popover_add_to_team')

module.exports = t.renderable ({ teamType }) ->
  t.p '.u-text-align-center', { style: 'padding: 3px 0' }, ->
    t.format 'add to team-disclaimer', { teamType }
  t.button '.button-link.primary.u-width-100.js-add-to-team', ->
    t.format 'add to team-confirm'
